import React from 'react';
import PropTypes, { any } from 'prop-types';

import styles from './matchSheetMatchData.scss';
import TextFrame from '../TextFrame';

const MatchSheetMatchData = (props) => {
    const {
        showReferee,
        match,
    } = props;

    const { courtNumber, matchPositionDisplay, drawNameDisplay, officialName, matchScoringTypeName } = match;

    return (
        <div className={styles.matchSheetMatchData}>
            <div className={styles.firstHalf}>
                <TextFrame
                    className={`${styles.wrapper} ${styles.drawName}`}
                    title="DRAW NAME"
                    description={drawNameDisplay}
                />
                <TextFrame
                    className={`${styles.wrapper} ${styles.match}`}
                    title="MATCH"
                    description={matchPositionDisplay}
                />
                <TextFrame
                    className={`${styles.wrapper} ${styles.court}`}
                    title="COURT"
                    description={courtNumber}
                />
            </div>
            <div className={styles.secondHalf}>
                {!showReferee && (
                    <TextFrame
                        className={`${styles.wrapper} ${styles.court}`}
                        title="COURT"
                        description={courtNumber}
                    />
                )}
                {showReferee && (
                    <TextFrame
                        className={`${styles.wrapper} ${styles.referee}`}
                        title="REFEREE"
                        description={officialName}
                    />
                )}
                <TextFrame
                    className={`${styles.wrapper} ${styles.scoringFormat}`}
                    title="SCORING FORMAT"
                    description={matchScoringTypeName}
                />
            </div>
        </div>
    );
};

MatchSheetMatchData.propTypes = {
    match: PropTypes.objectOf(any).isRequired,
    showReferee: PropTypes.bool,
};

MatchSheetMatchData.defaultProps = {
    showReferee: false,
};

export default MatchSheetMatchData;
